import sampleSize from 'lodash/sampleSize';
import { apiHolder as api } from 'api';
import { getTrackedUrl } from '@web-common/utils/download_track';
const fileApi = api.api.getFileApi();
export const randomName = () => `Lingxi_IMG_${sampleSize('0123456789'.split(''), 5).join('')}.png`;
export function downloadImg(url, name, fid, fileOriginUrl) {
    if (!url) {
        return;
    }
    const fileName = name || randomName();
    const trackedUrl = getTrackedUrl(url);
    if (!process.env.BUILD_ISELECTRON) {
        const a = document.createElement('a');
        const event = new MouseEvent('click');
        a.download = fileName;
        a.target = '_blank';
        a.href = trackedUrl || url;
        a.dispatchEvent(event);
    }
    else {
        const params = {
            fileName,
            fileUrl: url,
            fileSourceType: 3,
            fid,
            fileOriginUrl,
            fileUrlInUse: trackedUrl,
        };
        fileApi.saveDownload(params, { flowScene: 'mail_read' });
    }
}
